// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/deep/.el-table th.el-table__cell.is-leaf{border-bottom:none!important}", ""]);
// Exports
module.exports = exports;
